import { render, staticRenderFns } from "./OCPopupPreview.vue?vue&type=template&id=92ccc730&scoped=true&"
import script from "./OCPopupPreview.vue?vue&type=script&lang=ts&"
export * from "./OCPopupPreview.vue?vue&type=script&lang=ts&"
import style0 from "./OCPopupPreview.vue?vue&type=style&index=0&id=92ccc730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ccc730",
  null
  
)

export default component.exports